<template>
  <div class="register-page-container">
    <div class="register-form-container">
      <!-- 表单内容保持不变 -->
      <h2 class="title">{{ t('欢迎注册') }}</h2>
      <div class="link-container">
        <span>{{ t('已有账号？') }}</span>
        <el-link type="primary" :underline="false" @click="handleLoginFn">{{ t('登录') }}</el-link>
      </div>
      <el-form
        ref="registerForm"
        :model="formData"
        :rules="rules"
        class="form"
        @submit.prevent="handleSubmitFn"
      >
        <el-form-item prop="username">
          <el-input
            size="large"
            v-model="formData.username"
            :placeholder=" t('请设置用户名')  "
            prefix-icon="User"
          />
        </el-form-item>
        <el-form-item prop="phone">
          <el-input
            size="large"
            v-model="formData.phone"
            :placeholder="  t('可用于登录和找回密码')  "
            prefix-icon="Iphone"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            size="large"
            v-model="formData.password"
            type="password"
            :placeholder="  t('请设置登录密码') "
            prefix-icon="Lock"
            show-password
          />
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="formData.code"
            type="text"
            :placeholder="t('验证码')"
            prefix-icon="Message"
            size="large"
          >
            <template #append>
              <el-link
                type="link"
                @click="sendVerificationCodeFn"
                :disabled="leftTime!==0"
              >{{ t('发送验证码') }}{{ leftTime?`(${leftTime})`:"" }}</el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-button
          type="primary"
          size="large"
          class="submit-button"
          :loading="isLoadingSubmit"
          :disabled="isLoadingSubmit"
          @click="handleSubmitFn"
        >{{ t('注册') }}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
const router = useRouter();
const { t } = useI18n();
const formData = reactive({
  username: "",
  phone: "",
  password: "",
  code: ""
});
// 表单验证规则
const rules = reactive({
  username: [{ required: true, message: t("用户名不能为空"), trigger: "blur" }],
  phone: [
    { required: true, message: t("手机号不能为空"), trigger: "blur" },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: t("请输入正确手机号"),
      trigger: "blur"
    }
  ],
  password: [
    { required: true, message: t("密码不能为空"), trigger: "blur" },
    { min: 6, max: 20, message: t("密码长度6 - 20位"), trigger: "blur" }
  ],
  code: [{ required: true, message: t("验证码不能为空"), trigger: "blur" }]
});
const leftTime = ref(0);
const sendVerificationCodeFn = () => {
  leftTime.value = 29;
  const t = setInterval(() => {
    if (leftTime.value) {
      leftTime.value--;
    } else {
      clearInterval(t);
    }
  }, 1000);
};
const isLoadingSubmit = ref(false);
const handleSubmitFn = () => {
  isLoadingSubmit.value = true;
  setTimeout(() => {
    ElMessage.success(t("注册成功"));
    isLoadingSubmit.value = false;
  }, 1500);
};
const handleLoginFn = () => {
  router.push("/");
};
</script>
<style lang="scss">
.register-page-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: url("@/assets/img/login.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0 0;
  display: flex;
  justify-content: center;
  align-items: center; 
  animation: bgScroll 60s linear infinite;
}
 
@keyframes bgScroll {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.register-form-container {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 3rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 400px;
  z-index: 1;

  .title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .link-container {
    margin-bottom: 1.5rem;
    text-align: right;
    font-size: 0.9rem;
  }

  .form {
    width: 100%;

    .el-form-item {
      margin-bottom: 1rem;
    }
  }

  .submit-button {
    width: 100%;
  }
}
</style>